import { render, staticRenderFns } from "./caidao-app.vue?vue&type=template&id=44c229a7&"
import script from "./caidao-app.vue?vue&type=script&lang=js&"
export * from "./caidao-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports